<template>
  <a-dropdown>
    <slot name="trigger" :record="record">
      <div class="action-button" :data-testid="triggerTestId" @click.stop="() => {}">
        <a-icon width="24" height="24" icon="fluent-mdl2:more" />
      </div>
    </slot>
    <a-menu slot="overlay" :data-testid="menuTestId">
      <template
        v-for="item in menuItems.filter(item =>
          typeof item.visible === 'function' ? item.visible(record) : item.visible
        )"
      >
        <a-sub-menu :key="item.key" v-if="item.children && item.children.length > 0">
          <span slot="title" class="flex gap-2 align-items-center">
            <a-icon width="20" height="20" :icon="item.icon" />
            {{ typeof item.label === 'function' ? item.label(record) : item.label }}
          </span>
          <a-menu-item
            v-for="child in item.children"
            @click="child.handler(record)"
            :key="child.key"
            :disabled="child.disabled"
            :data-testid="child.testId"
          >
            <div class="flex gap-2 align-items-center">
              <a-icon width="20" height="20" :icon="child.icon" />
              {{ typeof child.label === 'function' ? child.label(record) : child.label }}
            </div>
          </a-menu-item>
        </a-sub-menu>

        <a-menu-item
          v-else
          @click="item.handler(record)"
          :key="typeof item.label === 'function' ? item.label(record) : item.label"
          :disabled="item.disabled"
          :data-testid="item.testId"
        >
          <div class="flex gap-2 align-items-center">
            <a-icon width="20" height="20" :icon="item.icon" />
            {{ typeof item.label === 'function' ? item.label(record) : item.label }}
          </div>
        </a-menu-item></template
      >
    </a-menu>
  </a-dropdown>
</template>

<script>
import { Dropdown, Menu } from 'ant-design-vue'

export default {
  name: 'ButtonMore',
  components: {
    'a-dropdown': Dropdown,
    'a-menu': Menu,
    'a-menu-item': Menu.Item,
    'a-sub-menu': Menu.SubMenu
  },
  props: {
    record: {
      type: Object,
      default: () => {}
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    triggerTestId: {
      type: String,
      default: undefined
    },
    menuTestId: {
      type: String,
      default: undefined
    }
  }
}
</script>
